export const name = 'eurotech'
export const title = 'Eurotech ERP Software'
export const startDate = '2019-01-01'
export const poweredBy = {
	text: 'JKL InfoSolutions',
	link: 'https://jklinfosolutions.com'
}

export default { name, title, poweredBy, startDate }